import "tailwindcss/tailwind.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { Suspense, useRef } from "react";
import ProtectedRoute from "./components/core/auth-layout/ProtectedRoute";
import LoginPage from "./pages/auth/login";
import BasicLayout from "./components/core/basic-layout";
import routes from "./routes";
import ForgotPasswordPage from "./pages/auth/forgotpass";
import { ToastContainer } from "react-toastify";
import NotFoundPage from "./pages/notfound";
import SignupPage from "./pages/auth/signup/Signup";
// Legacy frontend-rendered treatment print — replaced by the backend
// Puppeteer case-sheet PDF (GET /api/treatment/case-sheet/:id).
// Keeping the import commented out in case we need to revert.
// import TreatmentPrint from "./components/prints/treatment-print";
import LabsInvoice from "./components/prints/labs-invoice";
import ConsentForm from "./components/ui/ConsentForm";
import { PWAWrapper } from "./hooks/usePWANavigation";
import AlertPreview from "./components/ui/Settings/AccountStatus/AlertPreview";

function App() {
  const protectedRouteRef = useRef();

  return (
    <Router>
      <ToastContainer />
      <PWAWrapper />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/signup" element={<SignupPage />} />
        {/* <Route path="/treatment-print" element={<TreatmentPrint />} /> */}
        <Route path="/lab-print" element={<LabsInvoice />} />
        <Route path="/consent-print" element={<ConsentForm />} />
        {/* Development-only gallery of the account notices. */}
        {process.env.NODE_ENV !== "production" && (
          <Route path="/alerts-preview" element={<AlertPreview />} />
        )}

        {/* Protucted Routes */}
        <Route
          element={
            <ProtectedRoute ref={protectedRouteRef}>
              <BasicLayout protectedRouteRef={protectedRouteRef} />
            </ProtectedRoute>
          }
        >
          {routes.map(({ path, component: Component }, index) => (
            <Route
              key={index}
              path={path}
              element={
                <Suspense fallback={null}>
                  <Component />
                </Suspense>
              }
            />
          ))}
          {/* 404 Page */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route index element={<Navigate to={`/appointments`} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
